import { render, staticRenderFns } from "./ProDesc.vue?vue&type=template&id=11889cc2&scoped=true"
import script from "./ProDesc.vue?vue&type=script&lang=js"
export * from "./ProDesc.vue?vue&type=script&lang=js"
import style0 from "./ProDesc.vue?vue&type=style&index=0&id=11889cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11889cc2",
  null
  
)

export default component.exports